import React, { useState, useEffect, useMemo, memo, useLayoutEffect } from 'react';
import cn from 'classnames';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import NumberKeyboard from '@components/common/formElements/SimpleKeyboard/numberKeyboard';
import { getObjectValue, urlSearchParams } from '../../utility/utills';
import { flowType } from '@utility/userInfo';
import styles from './receiptScreen.module.scss';
import { ReactComponent as SearchDetailsTwo } from '@assets/images/SearchDetailsTwo.svg';
import ERROR from '@assets/images/GIFs/ERROR.gif';
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import { connect } from 'react-redux';
import EventEmitter from '@utility/eventSubscribers';
import { safeJsonParse, FormatLoyaltyPhoneNumber } from '@utility/helperFunction';

const ReceiptScreen = ({
  tableData,
  currenySymbol,
  renderModifier,
  renderModifierView,
  paymentType,
  tipAmount,
  active,
  isKiosk,
  isServerApp,
  handleButtonClick,
  handleKeyboardValue,
  keyboardValue,
  paymentFlowType,
  paidTips = 0,
  unpaidTips = 0,
  countryCode,
  fontSize = 'fs-24',
  supportsTips,
  paymentCheck,
  noRoundedBorder,
  deviceInfo,
  allMenuItems,
  ShowLandscapeMode,
  PaymentPageBtn,
  setViewDetailsOpen,
  viewDetailsOpen,
  serverAppTheme,
  isWalkUp,
  isPaymentTerminal,
  isTogo,
  isOrderingPortrait,
  paymentLandscapeOrientation,
  ...props
}) => {
  const isLandScape = true;
  const tipAmounts = tipAmount > 0 ? tipAmount : null;
  const currentTipValue =
    tableData && tableData?.paymentCheck?.tipAmount > 0
      ? tableData?.paymentCheck?.tipAmount?.toFixed(2)
      : tipAmounts;
  const itemizedTipPercent = tableData?.paymentCheck?.tip?.tipTypeValue;
  const serviceChargeAmount = getObjectValue(
    () => tableData.serviceChargeAmount,
    0
  );
  const seatClassname =
    'fw-500 color-black  roundedSm d-flex justify-content-center align-items-center';
  
  const paymentLandingScreen = Number(urlSearchParams('screenType')) === 1;

  useLayoutEffect(() => {
    if (window.ReactNativeWebView) {
        if ((paymentLandingScreen && isOrderingPortrait) || (!paymentLandingScreen && !paymentLandscapeOrientation)) {
          EventEmitter.changeOrientation({
            orientation: "portrait"
          })
        } else {
          EventEmitter.changeOrientation({
            orientation: "landscape"
          })
        }
    }
  }, [isOrderingPortrait, paymentLandingScreen, paymentLandscapeOrientation])

  // single check presenter screen dynamic height
  const [dynamicHeight, setDynamicHeight] = useState({ itemList: "" });
  const deviceInfos = JSON.parse(window.sessionStorage.getItem('deviceInfo'));

  const forCheckPresenter = Number(urlSearchParams('screenType')) === 28 && urlSearchParams('type') === 'payType';
const auth =    safeJsonParse(window.sessionStorage.getItem('auth'), {});
const footerlines = auth?.footerLines;
  const adjustHeight = () => {
    const totalInnerDiv = document.querySelectorAll("#innerDiv")?.length || 0;
    const state = getLoyaltyOfferState(); // 0, 1, or 2

    let baseHeight;
    let baseHeight2;

    if (totalInnerDiv === 2) {
      baseHeight = 90;
      baseHeight2 = 73;
    } else if (totalInnerDiv === 3) {
      baseHeight = 86;
      baseHeight2 =70.5;
    } else if (totalInnerDiv === 4) {
      baseHeight = 82;
      baseHeight2 = 68;
    } else if (totalInnerDiv === 5) {
      baseHeight = 79;
      baseHeight2 =64.5;
    } else if (totalInnerDiv === 6) {
      baseHeight = 76;
      baseHeight2 = 62;
    } else if (totalInnerDiv === 7) {
      baseHeight = 72;
      baseHeight2 = 59;
    } else if (totalInnerDiv === 8) {
      baseHeight = 68;
      baseHeight2 = 56;
    } else if (totalInnerDiv === 9) {
      baseHeight = 65;
      baseHeight2 = 53;
    } else {
      baseHeight = 44;
      baseHeight2 = 44;
    }

    // Adjust further based on loyalty/offer state
    let adjustment = 0;

    if (state === 1) {
      adjustment = -5.2; // only loyalty
    } else if (state === 2) {
      adjustment = -11; // loyalty + one offer
    } else if (state === 3) {
      adjustment = -17; // loyalty + more than one offer
    }
  const getLineCount = (lines) =>
  lines?.reduce((total, line) => total + Math.ceil(line.length / 65), 0); 
 const footerLineCount = footerlines && Array.isArray(footerlines) ? Math.min(getLineCount(footerlines), 5) : 0;

    const footerAdjustment = footerLineCount > 0 ? -(footerLineCount * 2) : 0;
    const finalHeight = ( forCheckPresenter ? baseHeight2 : baseHeight) + adjustment + footerAdjustment ;
    setDynamicHeight({ itemList: finalHeight });
    return { itemList: finalHeight };
  }

  useEffect(() => {
    adjustHeight();
  }, [tableData]);

  const isDefaultMode = getObjectValue(
    () =>
      !deviceInfo.deviceGroup || [0].includes(deviceInfo.deviceGroup.startMode),
    false
  );
  const payType = new URLSearchParams(window.location.search).get('type');

  const excludeItemFromReceiptScreen = item => {
    let excludeProduct = false;
    allMenuItems?.forEach(insideItems => {
      if (
        insideItems.id === item.menuItemId &&
        insideItems?.excludeFromReceipt
      ) {
        excludeProduct = true;
      }
    });
    return excludeProduct;
  };

  const isTableTop = flowType() === 'tableTop';
  const isCounter = getObjectValue(
    () => [1].includes(deviceInfo.deviceGroup.startMode),
    false
  );

  const isDriveThru = getObjectValue(
    () => [3].includes(deviceInfos.deviceGroup.startMode),
    false
  );
  const isCallCenter = getObjectValue(
    () => [2].includes(deviceInfos.deviceGroup.startMode),
    false
  );

  const taxAmoutWithTotal =
    (isCounter || isDriveThru || isCallCenter) && Number(urlSearchParams('screenType')) === 16
      ? Number(tableData?.totalAmount) + Number(tableData?.taxAmount)
      : tableData?.totalAmount;

  const seatNumber = (item) => {
    if (!item?.seats || item.seats.length === 0) return '';

    const firstSeat = item.seats[0];

    // Case 1: Multiple seats
    if (item.seats.length > 1) return firstSeat?.tableOrder ? 'T' : 'S';

    // Case 2: Single seat — look up number from props.seat.seats
    const matchedSeat = props?.seat?.seats?.find(
      (el) => el?.id === firstSeat?.seatId
    );

    return matchedSeat?.number ?? '';
  };

  const checkLoyalty = () => {
    if (payType === "payType") {
      const isLoyalty = props?.seat?.paymentCheck?.loyalty ?? null;
      return isLoyalty;
    } else {
      const isLoyalty = tableData?.loyalty ?? null;
      return isLoyalty;
    }
  };

  const checkOffer = () => {
    let offers = null;
    if (payType === "payType") {
      offers = props?.seat?.paymentCheck?.offers ?? null;
    } else {
      offers = tableData?.offers ?? null;
    }
    return offers;
  };

  const seatData = JSON.parse(window.sessionStorage.getItem('seat'));
  const isShowOffers = seatData?.paymentCheck?.offer?.saved === true;
  // const displayCoupon = seatData?.paymentCheck?.offer?.isCoupon;
  const displayCoupon = seatData?.paymentCheck?.offers?.some(
  offer => offer?.isCoupon === true
) ?? false;
  const orderLoyalty = seatData?.paymentCheck?.loyalty?.saved;

  const getLoyaltyOfferState = () => {
    const loyalty = checkLoyalty() ?? null;
    const offers = checkOffer() ?? null;

    if (loyalty && Array.isArray(offers) && offers.length > 0) {
      return offers.length > 1 ? 3 : 2; // both loyalty and offers (3 if multiple offers)
    } else if (loyalty) {
      return 1; // only loyalty
    } else {
      return 0; // neither
    }
  }

  const handleItemContainerHeight = () => {   
    if (document.querySelectorAll('#innerDiv').length === 3) {
      return isOrderingPortrait ? 'h-83' : 'h-73';
    } else if (document.querySelectorAll('#innerDiv').length === 4) {
      return 'h-67';
    } else if (document.querySelectorAll('#innerDiv').length === 5) {
      return isOrderingPortrait ? 'h-76' : 'h-62';
    } else if (document.querySelectorAll('#innerDiv').length === 6) {
      return 'h-57';
    } else {
      return  isOrderingPortrait ? 'h-69' : 'h-52';
    }
  };
  return (
    <>
      {![6, 7, 8, 4, 13, 24, 36, (isCounter || isDriveThru || isCallCenter) ? '' : 3].includes(paymentType) && (
        <>
          {countryCode !== '44' &&
          paymentFlowType !== 1 &&
          payType !== 'payType' &&
          paymentType !== 1 &&
          !['1', '9', '10', '17', '18'].includes(
            Number(urlSearchParams('screenType'))
          ) &&
          (!isCounter || !isDriveThru || isCallCenter) &&
          !viewDetailsOpen ? (
            <div
              className={cn(
                isKiosk || isTableTop
                  ? 'd-none'
                  : 'h-5 text-center py-0 od-text-primary w-100'
              )}
            >
              {LABEL().STAGE}:{tableData?.stage?.code}{' '}
              {tableData?.stage?.name ? (
                <span>
                  (
                  <span className={styles.truncate}>
                    {' '}
                    {tableData.stage.name}
                  </span>
                  )
                </span>
              ) : (
                tableData?.stage?.name
              )}
            </div>
          ) : null}
          {[2, 17, 18].includes(paymentType) && (
            <div
              className="row mx-0 flex-column w-100"
              style={{
                height:
                  [17, 18].includes(paymentType) && ((isCounter || isDriveThru || isCallCenter) ? '6%' : '5%'),
              }}
            >
              <div
                className={cn(
                  'd-flex align-items-center',
                  [17, 18].includes(paymentType) ? '' : 'pb-2'
                )}
              >
                <div
                  className={cn(
                    styles.tableOrderNum,
                    'col-12 d-flex align-items-center',
                    (isCounter || isDriveThru || isCallCenter) ? 'px-0' : 'justify-content-center'
                  )}
                >
                  <span
                    style={{
                      color: serverAppTheme?.primary_text,
                      fontSize: (isCounter || isDriveThru || isCallCenter) && '18px',
                    }}
                    className={cn(
                      [17, 18].includes(paymentType) &&
                        ((isCounter || isDriveThru || isCallCenter) ? 'px-0 justify-content-left ' : 'fs_24')
                    )}
                  >
                    {' '}
                    {LABEL().TABLE}{' '}
                    {props?.seat?.stationName ||
                      props?.seat?.name ||
                      props?.seat?.stationNumber}
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* item list start */}
          {(![17].includes(paymentType) || isCounter || isDriveThru || isCallCenter) &&
            (tableData?.items && tableData?.items?.length > 0 ? (
              // items and discount //
              <div
                className={cn(
                  'px-0 w-100 od-text-primary overflowY',
                  forCheckPresenter ? 'pt-2' : '',
                  paymentLandscapeOrientation ? 'mt-3' : '',
                  viewDetailsOpen && getLoyaltyOfferState() === 0 && 'mb-2',
                  [17, 18].includes(paymentType) && (!isCounter || !isDriveThru || !isCallCenter) && 'mt-1',
                  isTableTop ||
                    isKiosk ||
                    ShowLandscapeMode ||
                    [23].includes(paymentType)
                    ? ''
                    : [1].includes(paymentType)
                      ? PaymentPageBtn[1] !== null && PaymentPageBtn[2] !== null
                        ? handleItemContainerHeight()
                        : 'h-68'
                      : [17, 18].includes(paymentType)
                        ? ''
                        : [28].includes(paymentType)
                          ? getLoyaltyOfferState() === 0 && 'mb-2'
                          : '',
                  { 'px-2 mt-4 pb-2': isTableTop && !noRoundedBorder }
                )}
                style={{
                  color: '#FFF',
                  height: ![1].includes(paymentType) && `${dynamicHeight.itemList}${forCheckPresenter ? 'vh' : '%'}`,
                }}
              >
                {[18].includes(paymentType) ||
                  ([17].includes(paymentType) && (isCounter || isDriveThru || isCallCenter)) ||
                  paymentType === 1 ||
                  (paymentType === 3 && (isCounter || isDriveThru || isCallCenter)) ||
                  (viewDetailsOpen && (
                    <div
                      className={cn(
                        'h-4 w-100 align-content-center fs-18 fw-400',
                        !isServerApp && 'row',
                        isServerApp
                          ? 'col-12 d-flex'
                          : (isCounter)
                          ? 'col-12 mx-1'
                          : viewDetailsOpen
                          ? 'pl-3 px-0'
                          : 'mx-2'
                      )}
                      style={{
                        fontFamily: 'Poppins',
                        height:
                          ([17, 18].includes(paymentType) ||
                            ([3].includes(paymentType) && (isCounter || isDriveThru || isCallCenter))) &&
                          '4%',
                        fontSize: isLandScape && '14px',
                        color: serverAppTheme?.itemQtyClr,
                      }}
                    >
                      <div className={cn('col-2 p-0 text-center')}>
                        {' '}
                        <span> {LABEL().QTY}</span>
                      </div>
                      <div
                        className={cn(
                          'p-0 text-left',
                          isLandScape
                            ? (isCounter)
                              ? [17, 18, 3].includes(paymentType)
                                ? 'col-8 px-0'
                                : 'col-6 px-0'
                              : viewDetailsOpen
                              ? (isDriveThru || isCallCenter) ? 'col-8 px-0' : 'col-6 px-0'
                              : 'col-4 px-0'
                            : 'col-7'
                        )}
                      >
                        <div className="mx-0">{LABEL().ITEMS_LIST}</div>
                      </div>
                      {!(isDriveThru || isCallCenter) && (
                        (isCounter && [17, 18, 3].includes(paymentType)) ? null : (
                          <div
                            className={cn(
                              'p-0 text-left',
                              isLandScape
                                ? (
                                  isCounter
                                    ? 'col-2 px-0'
                                    : (viewDetailsOpen ? 'col-2 px-0' : 'col-3 px-0 text-center pr-3')
                                )
                                : 'col-1'
                            )}
                          >
                            <span> Seat</span>
                          </div>
                        )
                      )}
                      <div
                        className={cn(
                          ((isCounter) || isServerApp) &&
                            props.viewDetails &&
                            props.isLandScape
                            ? 'text-right'
                            : (isCounter)
                            ? 'col-3 text-right p-0'
                            : 'p-0 text-right',
                          isLandScape && !props.viewDetails
                            ? (isCounter)
                              ? 'col-2 px-0'
                              : viewDetailsOpen
                              ? 'col-2'
                              : 'col-3'
                            : isLandScape
                            ? 'col-3 px-0'
                            : viewDetailsOpen
                            ? 'col-2'
                            : 'col-3',
                          (!isLandScape || isServerApp) && (!isCounter || !isDriveThru || isCallCenter) && 'pl-5'
                        )}
                      >
                        <span>{LABEL().AMOUNT}</span>
                      </div>
                    </div>
                  ))}
                {/* ITEMS */}
                {tableData?.items &&
                  tableData?.items?.map(item => {
                    const excludeFromReceipt = excludeItemFromReceiptScreen(
                      item
                    );
                    return (
                      <>
                        {!excludeFromReceipt && (
                          <div
                            key={item.menuItemId}
                            className={cn(isOrderingPortrait ? 'px-0' : '',
                              'col-12 row mx-0 mt-1 py-2 w-100 align-content-center fw-400',
                              (paymentType === 28 || viewDetailsOpen) && 'pl-0',
                              ![1].includes(paymentType) && props.viewDetails
                                ? styles.spanForPayment
                                : styles.spanForPaymentt
                            )}
                            style={{
                              background: [1, 28].includes(paymentType)
                                ? serverAppTheme?.itemsBg
                                : props.viewDetails
                                ? serverAppTheme?.send_tab_unselected
                                : serverAppTheme?.checkDetail_tabs,
                              fontSize:
                                isLandScape && !props.viewDetails
                                  ? '18px'
                                  : '12px',
                              borderRadius: '4px',
                            }}
                          >
                            {/* 1. Quantity */}
                            <div
                              style={{ color: serverAppTheme?.primary_text }}
                              className={cn(
                                'p-0',
                                (isCounter)
                                  ? 'col-1 px-0 text-center'
                                  : [1].includes(paymentType)
                                  ? 'col-1 text-center'
                                  : 'col-2 px-1 text-center'
                              )}
                            >
                              {' '}
                              <span>
                                {item?.split > 1
                                  ? `${item?.quantity}/${item?.split}`
                                  : item?.quantity}
                              </span>
                            </div>
                            {/* 2. Items */}
                            <div
                              style={{ color: serverAppTheme?.primary_text }}
                              className={cn(
                                'p-0 text-left',
                                isLandScape
                                  ? (isCounter)
                                    ? [17, 18, 3].includes(paymentType)
                                      ? 'col-8 px-0'
                                      : 'col-6 px-0'
                                    : [1].includes(paymentType)
                                    ? 'col-7 px-0'
                                    : paymentType === 28
                                    ? 'col-6 px-0'
                                    : viewDetailsOpen
                                    ? (isDriveThru || isCallCenter) ? 'col-8 px-0' : 'col-6 px-0'
                                    : 'col-4 px-0'
                                  : isWalkUp
                                  ? 'col-8'
                                  : 'col-7'
                              )}
                            >
                              <div className="mx-0">
                                {[2, 17, 18, 23].includes(paymentType) &&
                                !['payType', 'null', 'credit'].includes(
                                  'payType'
                                ) ? (
                                  <span
                                    className={cn(
                                      'p-0 fs-16',
                                      item.quantity > 1 ||
                                        tableData.splitValue > 1
                                        ? 'col-4'
                                        : ''
                                    )}
                                  >
                                    {`${
                                      item.quantity > 1 ||
                                      tableData.splitValue > 1
                                        ? `${item.quantity}${
                                            tableData.splitValue > 1
                                              ? `/${tableData.splitValue} `
                                              : ''
                                          }x `
                                        : ''
                                    }`}
                                    {`${item.splitValueString}${item.menuItemName}`}
                                  </span>
                                ) : (
                                  <span
                                    className={cn(
                                      'p-0',
                                      item.quantity > 1 ||
                                        tableData.splitValue > 1
                                        ? ''
                                        : 'col-11'
                                    )}
                                  >
                                    {item.menuItemName}
                                  </span>
                                )}
                              </div>
                            </div>
                            {/* 3. Seat number */}
                            {item?.seats ? (
                              (isCounter || isDriveThru || isCallCenter) ? (
                                [17, 18].includes(paymentType) ? (
                                  <></>
                                ) : ([3].includes(paymentType) && (isCounter || isDriveThru || isCallCenter)) ||
                                  isWalkUp ? (
                                  <></>
                                ) : (
                                  <div
                                    className={cn(
                                      'col-1 d-flex',
                                      (isCounter || isDriveThru || isCallCenter) ? 'px-1' : 'px-0',
                                      isLandScape
                                        ? 'col-2'
                                        : !props.viewDetails
                                        ? ''
                                        : 'justify-content-center'
                                    )}
                                  >
                                    <div
                                      className={cn(seatClassname)}
                                      style={{
                                        width: '2.10044rem',
                                        height: '1.25rem',
                                        fontSize: !props.viewDetails
                                          ? '18px'
                                          : '12px',
                                        background: serverAppTheme?.seat_bg,
                                        color: serverAppTheme?.seat_box_text,
                                      }}
                                    >
                                      {item?.seats?.length > 1
                                        ? item?.seats[0]?.tableOrder
                                          ? 'T'
                                          : 'S'
                                        : props?.seat?.seats?.filter(
                                            i =>
                                              i?.id === item?.seats[0]?.seatId
                                          )[0]?.number}
                                    </div>
                                  </div>
                                )
                              ) : (
                                <div
                                  className={cn(
                                    [1].includes(paymentType)
                                      ? 'col-1'
                                      : `col-2 d-flex ${
                                          viewDetailsOpen
                                            ? 'align-items-center'
                                            : 'justify-content-center'
                                        }`,
                                    (isCounter || isDriveThru || isCallCenter)
                                      ? 'px-1'
                                      : paymentType === 28
                                      ? 'px-0 pr-0 align-items-center'
                                      : viewDetailsOpen
                                      ? 'px-0 pl-1 '
                                      : 'px-0 pr-3'
                                  )}
                                >
                                  <div
                                    className={cn(seatClassname)}
                                    style={{
                                      width: !props.viewDetails
                                        ? '1.8rem'
                                        : '2.1rem',
                                      height: '1.25rem',
                                      background: serverAppTheme?.seat_bg,
                                      color: serverAppTheme?.seat_box_text,
                                    }}
                                  >
                                    {item?.seats?.length > 1
                                      ? item?.seats[0]?.tableOrder
                                        ? 'T'
                                        : 'S'
                                      : props?.seat?.seats?.filter(
                                          i => i?.id === item?.seats[0]?.seatId
                                        )[0]?.number}
                                  </div>
                                </div>
                              )
                            ) : ([3].includes(paymentType) && (isCounter || isDriveThru || isCallCenter)) ||
                              isWalkUp ? (
                              <></>
                            ) : (
                              <>
                              {!(isDriveThru || isCallCenter) &&
                              <div
                                className={cn(
                                  [1].includes(paymentType)
                                    ? 'col-1'
                                    : `col-2 d-flex ${
                                        viewDetailsOpen
                                          ? 'align-items-center'
                                          : 'justify-content-center'
                                      }`,
                                  (isCounter || isDriveThru || isCallCenter)
                                    ? 'px-1'
                                    : paymentType === 28
                                    ? 'px-0 pr-0 align-items-center'
                                    : viewDetailsOpen
                                    ? 'px-0 pl-1 '
                                    : 'px-0 pr-3'
                                )}
                              >
                                <div
                                  className={cn(seatClassname)}
                                  style={{
                                    width: !props.viewDetails
                                      ? '1.8rem'
                                      : '2.1rem',
                                    height: '1.25rem',
                                    background: serverAppTheme?.seat_bg,
                                    color: serverAppTheme?.seat_box_text,
                                  }}
                                >
                                  {seatNumber(
                                    urlSearchParams('ticketSplitTypeId') === 1
                                      ? item
                                      : props?.seat?.Items?.filter(
                                          i => i.id === item.id
                                        )[0]
                                  )}
                                </div>
                              </div>}
                              </>
                            )}
                            {/* 4. Price */}
                            <div
                              style={{ color: serverAppTheme?.primary_text }}
                              className={cn(
                                'text-right',isOrderingPortrait ? 'pr-2 pl-0' : 'px-0',
                                {
                                  'col-3':
                                    (isCounter) || [1, 3].includes(paymentType),
                                  'col-2':
                                    paymentType === 28 || viewDetailsOpen,
                                  'col-4':
                                    ![3, 1, 28].includes(paymentType) &&
                                    !viewDetailsOpen,
                                  'pr-0': viewDetailsOpen,
                                },
                                (isServerApp || !isLandScape) &&
                                  (!isCounter || !isDriveThru || isCallCenter) &&
                                  ![1, 28].includes(paymentType) &&
                                  'pl-5'
                              )}
                            >
                              {currenySymbol}
                              {item.price.toFixed(2)}
                            </div>
                            {(isLandScape && !props.viewDetails) ||
                            (isCounter || isDriveThru || isCallCenter) ? (
                              <div className="col-12 p-0">
                                {item.modifiers &&
                                  renderModifierView(item.modifiers)}
                              </div>
                            ) : (
                              <div
                                className={cn(
                                  'col-12 p-0',
                                  item.modifiers && 'mt-2'
                                )}
                              >
                                {item.modifiers &&
                                  renderModifierView(item.modifiers)}
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    );
                  })}
                {/* DISCOUNT */}
                {props.seat?.paymentCheck?.discounts?.length > 0 &&
                  props.seat?.paymentCheck?.discounts.map(item => (
                    <div
                      key={item.discountId}
                      className={cn(
                        'col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500',
                        (paymentType === 28 || viewDetailsOpen) && 'pl-0',
                        ![1].includes(paymentType) && props.viewDetails
                          ? styles.spanForPayment
                          : styles.spanForPaymentt
                      )}
                      style={{
                        background: [1, 28].includes(paymentType)
                          ? serverAppTheme?.itemsBg
                          : props.viewDetails
                          ? serverAppTheme?.send_tab_unselected
                          : serverAppTheme?.checkDetail_tabs,
                        borderRadius: '4px',
                        color: serverAppTheme?.primary_text,
                      }}
                    >
                      <div
                        className={cn(
                          [1].includes(paymentType)
                            ? 'col-1 px-0'
                            : 'col-2 pl-3 pr-0'
                        )}
                      ></div>
                      <div
                        className={cn(
                          'px-0 text-left',
                          [1].includes(paymentType) ? 'col-7' : 'col-6'
                        )}
                      >
                        {item?.discountName}
                      </div>
                      <div
                        className={cn(
                          [1].includes(paymentType)
                            ? 'col-1'
                            : `col-2 d-flex ${
                                viewDetailsOpen
                                  ? 'align-items-center'
                                  : 'justify-content-center'
                              }`,
                          (isCounter || isDriveThru || isCallCenter)
                            ? 'px-1'
                            : paymentType === 28
                            ? 'px-0 pr-0 align-items-center'
                            : viewDetailsOpen
                            ? 'px-0 pl-1 '
                            : 'px-0 pr-3'
                        )}
                      >
                        <div
                          className={cn(seatClassname)}
                          style={{
                            width: !props.viewDetails ? '1.8rem' : '2.1rem',
                            height: '1.25rem',
                            background: serverAppTheme?.seat_bg,
                            color: serverAppTheme?.seat_box_text,
                          }}
                        >
                          {props.seat?.discounts?.filter(
                            i => i.discountId === item.discountId
                          )[0]?.seats?.length > 1
                            ? props.seat?.discounts?.filter(
                                i => i.discountId === item.discountId
                              )[0]?.seats[0]?.tableOrder
                              ? 'T'
                              : 'S'
                            : props.seat?.seats?.filter(
                                it =>
                                  it.id ===
                                  props.seat?.discounts?.filter(
                                    i => i.discountId === item.discountId
                                  )[0]?.seats[0]?.seatId
                              )[0]?.number}
                        </div>
                      </div>
                      <div
                        className={cn(
                          [1].includes(paymentType) ? 'col-3' : 'col-2 ',
                          'px-0 text-right'
                        )}
                      >
                        -{currenySymbol}
                        {item?.value?.toFixed(2)}
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              // no item found //
              <div
                className={cn(
                  'd-flex col-12 px-3 overflowY fs-600 justify-content-center align-items-center',
                  props.isLandScape ? 'fs-22' : 'fs-26 py-1'
                )}
                style={{
                  height: props.isLandScape
                    ? ''
                    : [17, 18, 1, 23, 19].includes(paymentType) &&
                      `${dynamicHeight.itemList}%`,
                  color: '#A0A0A0',
                }}
              >
                {CUSTOM_MESSAGES().NO_ITEM_FOUND}
              </div>
            ))}
          {['28', '31', '32'].includes(urlSearchParams('screenType')) && (
            <div
              className={cn(
                (getLoyaltyOfferState() !== 0 || displayCoupon) ? "mb-1" : ''
              )}
              style={{
                maxHeight: "150px", // optional: scroll if too many offers
                overflowY: "auto",
              }}
            >
              {/* Loyalty Info */}
              {checkLoyalty() && orderLoyalty && (
                <div
                  className={cn(
                    'col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex pl-75 justify-content-between',
                    styles.spanForPaymentt
                  )}
                  style={{
                    background: serverAppTheme?.itemsBg,
                    borderRadius: '4px',
                    color: serverAppTheme?.primary_text,
                  }}
                >
                  <div className="d-flex justify-content-start">
                    {Number(urlSearchParams('screenType')) === 31
                      ? LABEL().OS_LOYALTY
                      : LABEL().CHECK_PRESENTER_LOYALTY}{' '}
                    {checkLoyalty()?.displayAccountNumber && (
                      <>
                        (
                        {checkLoyalty()?.displayAccountNumber?.length > 30
                          ? `${checkLoyalty()?.displayAccountNumber.slice(0, 30)}...`
                          : FormatLoyaltyPhoneNumber(checkLoyalty()?.displayAccountNumber)}
                        )
                      </>
                    )}
                  </div>
                  <div className="d-flex justify-content-end">
                    <SuccessIcon />
                  </div>
                </div>
              )}

              {/* Loyalty Offers */}
              {Array.isArray(checkOffer()) &&
                checkOffer().length > 0 &&
                !displayCoupon &&
                checkOffer().map((offer, index) => (
                  <div
                    key={index}
                    className={cn(
                      'col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex pl-75 justify-content-between',
                      styles.spanForPaymentt
                    )}
                    style={{
                      background: serverAppTheme?.itemsBg,
                      borderRadius: '4px',
                      color: serverAppTheme?.primary_text,
                    }}
                  >
                    <div className="d-flex justify-content-start">
                      {offer?.name?.length > 30
                        ? `${offer.name.slice(0, 30)}...`
                        : offer.name}
                    </div>
                    <div className="d-flex justify-content-end">
                      <SuccessIcon />
                    </div>
                  </div>
                ))}

              {/* Coupon */}
              {displayCoupon && ['31', '32', '28'].includes(urlSearchParams('screenType')) && (
                <div
                  className={cn(
                    'col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex pl-75 justify-content-between',
                    styles.spanForPaymentt
                  )}
                  style={{
                    background: serverAppTheme?.itemsBg,
                    borderRadius: '4px',
                    color: serverAppTheme?.primary_text,
                  }}
                >
                  <div className="d-flex justify-content-start">
                    {/* {seatData?.paymentCheck?.offer?.name
                      ? seatData?.paymentCheck?.offer?.name
                      : */}
                       {LABEL().RECEIPT_COUPON_KEY}
                  </div>
                  <div className="d-flex justify-content-end">
                    <SuccessIcon />
                  </div>
                </div>
              )}
            </div>
          )}


          {(isCounter || isDriveThru || isCallCenter) && [17, 18].includes(paymentType) ? (
            isLandScape &&
            tableData?.items &&
            tableData?.items?.length > 0 && (
              <div
                tabIndex="0"
                role="button"
                className={cn(' col-12 px-0 text-right', styles.viewDetails)}
                onClick={() => setViewDetailsOpen(true)}
              >
                <SearchDetailsTwo fill={serverAppTheme?.primary_text} />
                <span style={{ color: serverAppTheme?.primary_text }}>
                  {LABEL().VIEW_DETAILS}
                </span>
              </div>
            )
          ) : (
            <></>
          )}
          {props?.viewDetails ? (
            isLandScape &&
            props.checkListLength > 0 &&
            tableData?.items &&
            tableData?.items?.length > 0 && (
              <div
                tabIndex="0"
                role="button"
                className={cn('text-right', styles.viewDetails)}
                onClick={props.viewDetailsPopup}
              >
                <SearchDetailsTwo fill={serverAppTheme?.primary_text} />
                <span style={{ color: serverAppTheme?.primary_text }}>
                  {LABEL().VIEW_DETAILS}
                </span>
              </div>
            )
          ) : (
            <></>
          )}

          {/* amount list start */}
          {(![17].includes(paymentType) || isCounter || isDriveThru || isCallCenter) &&
            tableData?.items &&
            tableData?.items?.length > 0 && (
              <div
                className={cn(
                  `w-100 mx-0 px-0`,
                  [28].includes(paymentType) && 'position-relative',
                  viewDetailsOpen && 'overflowY',
                  `px-0 ${
                    PaymentPageBtn[1] === null && PaymentPageBtn[2] === null
                      ? 'pb-0'
                      : ''
                  }`,
                  [23, 19].includes(paymentType) &&
                    !isLandScape &&
                    'position-absolute',
                  [17, 18].includes(paymentType) &&
                    !isLandScape &&
                    'position-absolute ',
                  isLandScape && !props.viewDetails && '',
                  [3].includes(paymentType) &&
                    (isCounter || isDriveThru || isCallCenter) &&
                    'position-absolute pr-1'
                )}
                style={{
                  bottom: [1].includes(paymentType)
                    ? '0.45rem'
                    : [23, 19].includes(paymentType) && !isLandScape
                    ? '0'
                    : [3].includes(paymentType) && (isCounter || isDriveThru || isCallCenter)
                    ? 0
                    : [17, 18].includes(paymentType) && '0rem',
                  // paddingTop: '8px',
                  paddingBottom: ([28].includes(paymentType) && urlSearchParams('type') === 'payType') ? "0" : (isOrderingPortrait ? '0px' : '10px'),
                  fontSize: isLandScape && '0.875rem',
                  color:
                    isLandScape && props.checkListLength > 0
                      ? serverAppTheme?.primary_text
                      : '#000',
                  overflowY: 'clip',
                  zIndex:'999'
                }}
              >
                <div
                  className={cn(
                    'col-12 px-0 h-100',
                    [1, 23, 19, 28].includes(paymentType)
                      ? 'pt-2 position-relative d-flex align-items-end'
                      : '',
                    [3].includes(paymentType) &&
                      (isCounter || isDriveThru || isCallCenter) &&
                      'position-relative'
                  )}
                >
                  <div
                    className={cn(
                      'col-12 d-flex flex-column justify-content-center align-items-center',
                      ([17, 18, 23].includes(paymentType)
                        ? isLandScape
                          ? 'w-96-5'
                          : 'w-100 overflowY'
                        : 'w-100 h-100',
                      [23].includes(paymentType) && 'h-100'),
                      isLandScape
                        ? props.checkListLength === 0
                          ? styles.divForPaymentt
                          : styles.divForPayment
                        : styles.divForPayment,
                      [1, 17, 18, 23].includes(paymentType) && isLandScape
                        ? 'w-100 overflowY p-2'
                        : 'w-100 overflowY py-2',
                      [19].includes(paymentType) &&
                        'w-100 overflowY p-2 position-absolute',
                      [17, 18].includes(paymentType) && 'h-100',
                      isLandScape && !props.viewDetails && 'px-3'
                    )}
                    style={{
                      bottom: [1, 23, 19, 28].includes(paymentType)
                        ? '0px'
                        : [3].includes(paymentType) && (isCounter || isDriveThru || isCallCenter)
                        ? 0
                        : '',
                      maxHeight: [1, 19].includes(paymentType) ? '100%' : '',
                      overflow:
                        document.querySelectorAll('#innerDiv').length > 5
                          ? 'auto'
                          : [17, 18].includes(paymentType) && (isCounter || isDriveThru || isCallCenter)
                          ? 'scroll'
                          : document.querySelectorAll('#innerDiv').length > 4
                          ? 'scroll'
                          : 'hidden',
                      background:
                        props.checkListLength === 0
                          ? serverAppTheme?.seat_box_text
                          : serverAppTheme?.selector_control_color,
                      color: serverAppTheme?.primary_text,
                      paddingRight: '12px',
                      paddingLeft: '12px',
                    }}
                  >
                    {/* Items */}
                    {countryCode !== '44' &&
                      (tableData?.discounts?.length > 0 ||
                        props?.seat?.paymentCheck?.discounts?.length > 0 ||
                        props?.seat?.paymentCheck?.offer != null) && (
                        <div
                          id="innerDiv"
                          className={cn(
                            'row m-0 fw-400 fs_20 pb-1 w-100',
                            styles.paymentStyle
                          )}
                        >
                          <div className="col-6 p-0 fw-400 fs_20 text-left">
                            Items
                          </div>
                          <div className="col-6 p-0 fw-400 fs_20 text-right">
                            {currenySymbol}
                            {(tableData?.itemAmount ||
                              tableData?.itemAmount === 0) &&
                              tableData?.itemAmount?.toFixed(2)}
                          </div>
                        </div>
                      )}
                  {/* Discount */}
                  {tableData?.discountAmount > 0 && !props?.seat?.paymentCheck?.offer && (
                    <div
                      className="row m-0 fw-400 fs_20 pb-1 w-100"
                      id="innerDiv"
                    >
                      <div className={cn("col-6 p-0 fw-400 fs_20 text-left")}>
                        {LABEL().DISCOUNT_AMOUNT}
                      </div>
                      <div
                        className={cn(
                          "col-6 p-0 fw-400 fs_20 text-right"
                        )}
                      >
                        -{currenySymbol}
                        {Number(tableData?.discountAmount).toFixed(2)}
                      </div>
                    </div>
                  )}
                  {countryCode !== '44' && (
                    <div
                      className="row mx-0 fw-normal h-auto pb-1 w-100 fs_20"
                      id="innerDiv"
                    >
                      {['28', '31', '32'].includes(urlSearchParams('screenType')) &&
                        (props?.seat?.paymentCheck?.offer?.isCoupon ||
                          props?.seat?.paymentCheck?.offer) && (
                          <>
                            {isShowOffers && !props?.seat?.paymentCheck?.offer?.isCoupon ? (
                              <div className={cn('col-8 p-0 text-left')}>
                                {LABEL().DISCOUNT_AMOUNT}
                              </div>
                            ) : (
                              <div className={cn('col-8 p-0 text-left')}>
                                {props?.seat?.paymentCheck?.offer?.isCoupon
                                  ? LABEL().RECEIPT_COUPON_KEY
                                  : LABEL().RECEIPT_OFFER_KEY}{' '}
                                (
                                {props?.seat?.paymentCheck?.offer?.name?.length > 12
                                  ? `${props?.seat?.paymentCheck?.offer?.name.slice(0, 12)}...`
                                  : props?.seat?.paymentCheck?.offer?.name}
                                )
                              </div>
                            )}

                            <div className={cn('col-4 p-0 text-right fw-normal fs_20')}>
                              -{currenySymbol}
                              {!props?.seat?.paymentCheck?.offer?.isCoupon
                                ? props?.seat?.paymentCheck?.discountAmount?.toFixed(2)
                                : props?.seat?.paymentCheck?.offer?.value?.toFixed(2)}
                            </div>
                          </>
                        )}
                    </div>
                  )}



                    {countryCode === '44' ? (
                      <div
                        id="innerDiv"
                        className={cn(
                          'row m-0 fw-normal fs-22 w-100',
                          [1, 17, 18].includes(paymentType) && 'pb-1',
                          [23].includes(paymentType) && 'pb-2'
                        )}
                      >
                        <div className="col-8 p-0 text-left">
                          {LABEL().PAYEMENT_TOTAL_DUE}
                        </div>
                        {Number(urlSearchParams('screenType')) === 5 ? (
                          <div className="col-4 p-0 text-right">
                            {currenySymbol}
                            {(tableData?.totalAmount - tipAmount)?.toFixed(2)}
                          </div>
                        ) : (
                          <div
                            className={cn(
                              'col-4 px-0 text-right',
                              (!isCounter || !isDriveThru || !isCallCenter) && 'pb-1'
                            )}
                          >
                            {currenySymbol}
                            {taxAmoutWithTotal?.toFixed(2)}
                          </div>
                        )}
                      </div>
                    ) : (
                      // Sub Total
                      <div
                        id="innerDiv"
                        className={cn(
                          'row mx-0 fw-normal h-auto pb-1 w-100',
                          [1, 17, 18].includes(paymentType) && !isLandScape
                            ? 'fs_20 pb-2'
                            : !props.viewDetails
                            ? 'fs_20'
                            : 'fs-14',
                          [23].includes(paymentType) && 'pb-2 fs_20'
                        )}
                      >
                        <div className={cn('col-8 p-0 text-left')}>
                          {LABEL().SUB_TOTAL}
                        </div>
                        <div
                          className={cn(
                            'col-4 p-0 text-right  fw-normal',
                            !isLandScape || !props.viewDetails
                              ? 'fs_20'
                              : 'fs-14'
                          )}
                        >
                          {currenySymbol}
                          {(tableData?.subTotalAmount ||
                            tableData?.subTotalAmount === 0) &&
                            tableData?.subTotalAmount?.toFixed(2)}
                        </div>
                      </div>
                    )}
                    {/* Tax */}
                    <div
                      id="innerDiv"
                      className={cn(
                        'row mx-0 h-auto pb-1 w-100',
                        (!isLandScape || !props.viewDetails) && 'fs_20',
                        [1, 17, 18].includes(paymentType) && !isLandScape
                          ? 'fs_20 pb-2'
                          : 'fs-14',
                        [23].includes(paymentType) && 'pb-2 fs_20'
                      )}
                    >
                      <div className={cn('col-8 p-0 text-left')}>
                        {countryCode === '44' ? LABEL().VAT : LABEL().TAX}
                      </div>
                      <div
                        className={cn(
                          'col-4 p-0 text-right',
                          !props.viewDetails && 'fs_20'
                        )}
                      >
                        {currenySymbol}
                        {(tableData?.taxAmount || tableData?.taxAmount === 0) &&
                          tableData?.taxAmount?.toFixed(2)}
                      </div>
                    </div>
                    {serviceChargeAmount > 0 && (
                      <div
                        id="innerDiv"
                        className={cn(
                          'row mx-0 fw-normal fs_20 h-auto pb-1 w-100',
                          [1, 17, 18].includes(paymentType) && !isLandScape
                            ? 'fs_20 pb-2'
                            : 'fs-14',
                          [23].includes(paymentType) && 'pb-2 fs_20'
                        )}
                      >
                        <div className="col-8 p-0 text-left">
                          {LABEL().SERVICE_CHARGE}
                        </div>
                        <div className={cn('col-4 p-0 text-right')}>
                          {currenySymbol}
                          {serviceChargeAmount?.toFixed(2)}
                        </div>
                      </div>
                    )}
                    {[1, 20, 17, 18].includes(paymentType) &&
                      getObjectValue(() => tipAmount > 0, false) && (
                        <div
                          id="innerDiv"
                          className={cn(
                            'row m-0 fw-normal h-auto pb-1 w-100 fs_20',
                            [1, 17, 18].includes(paymentType) && !isLandScape
                              ? 'fs_20 pb-2'
                              : 'fs-14'
                          )}
                        >
                          <div className={cn('col-8 p-0 text-left')}>
                            {LABEL().TIP}
                          </div>
                          <div className={cn('col-4 p-0 text-right fs_20')}>
                            {currenySymbol}
                            {(tipAmount && Number(tipAmount)?.toFixed(2)) ||
                              tableData?.tipAmount?.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {/* Total */}
                    {countryCode !== '44' &&
                      ![20, 17, 18].includes(paymentType) && (
                        <div
                          id="innerDiv"
                          className={cn(
                            'row mx-0 align-items-center h-auto pb-1 w-100',
                            [1].includes(paymentType) && !isLandScape
                              ? 'fs_20 pb-2'
                              : !props.viewDetails
                              ? 'fs_20'
                              : 'fs-14',
                            [23].includes(paymentType) && 'pb-2 fs_20'
                          )}
                        >
                          <div className={cn('col-8 p-0 text-left fw-normal')}>
                            Total
                          </div>
                          <div
                            className={cn(
                              'col-4 p-0 text-right fw-normal',
                              isLandScape ? 'fs-14' : 'fs_20',
                              !props.viewDetails && 'fs_20'
                            )}
                          >
                            {currenySymbol}
                            {(tableData?.totalAmount ||
                              tableData?.totalAmount === 0) &&
                              tableData?.totalAmount?.toFixed(2)}
                          </div>
                        </div>
                      )}
                  {!isTogo &&
                    !isCallCenter && ((currentTipValue && itemizedTipPercent) ||
                      viewDetailsOpen) && (
                      <div
                        id="innerDiv"
                        className="row mx-0 fw-normal h-auto pb-1 fs_20 w-100"
                      >
                        <div className={cn('col-8 p-0 text-left')}>
                          {LABEL().RECEIPT_TIP}{' '}
                        </div>
                        <div
                          className={cn('col-4 p-0 text-right fw-normal fs_20')}
                        >
                          {currenySymbol}
                          {currentTipValue || '0.00'}
                        </div>
                      </div>
                    )}
                    {viewDetailsOpen && (props?.seat?.paymentCheck?.cash?.roundingAmount ?? 0) !== 0 && (
                      <div
                        id="innerDiv"
                        className="row mx-0 fw-normal h-auto pb-1 fs_20 w-100"
                      >
                        <div className={cn('col-8 p-0 text-left')}>
                          {LABEL().RECEIPT_ROUNDING}
                        </div>
                      <div
                        className={cn('col-4 p-0 text-right fw-normal fs_20')}
                      >
                        {(props?.seat?.paymentCheck?.cash?.roundingAmount ?? 0) < 0
                          ? `-${currenySymbol}${Math.abs(props?.seat?.paymentCheck?.cash?.roundingAmount ?? 0).toFixed(2)}`
                          : `${currenySymbol}${(props?.seat?.paymentCheck?.cash?.roundingAmount ?? 0).toFixed(2)}`
                        }
                      </div>
                      </div>
                    )}
                    {viewDetailsOpen && (
                      <div
                        id="innerDiv"
                        className="row mx-0 fw-normal h-auto pb-1 fs_20 w-100"
                      >
                        <div className={cn('col-8 p-0 text-left')}>
                          {LABEL().RECEIPT_ITEMIZED_PAYMENT}
                        </div>
                        <div
                          className={cn('col-4 p-0 text-right fw-normal fs_20')}
                        >
                          {currenySymbol}
                          {props?.seat?.paymentCheck?.paymentAmount?.toFixed(
                            2
                          ) || '0.00'}
                        </div>
                      </div>
                    )}
                    {/* Paid */}
                    {getObjectValue(() => tableData?.paidAmount > 0, false) &&
                      ![5].includes(paymentType) && (
                        <div
                          id="innerDiv"
                          className={cn(
                            'fs_20 row m-0 fw-normal h-auto pb-1 w-100',
                            [1, 17, 18].includes(paymentType) && isLandScape
                              ? ''
                              : 'fs_20 pb-2',
                            [23].includes(paymentType) && 'pb-2 fs_20'
                          )}
                        >
                          <div
                            className={cn(
                              'col-8 p-0 text-left',
                              isLandScape && 'fs-14',
                              !props.viewDetails && 'fs_20'
                            )}
                          >
                            Paid
                          </div>
                          <div
                            className={cn(
                              'col-4 p-0 text-right',
                              isLandScape && 'fs-14',
                              !props.viewDetails && 'fs_20'
                            )}
                          >
                            {currenySymbol}
                            {tableData?.paidAmount?.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {countryCode !== 44 && props.seat?.paymentCheck?.giftCard && (
                      <div
                        id="innerDiv"
                        className="row mx-0 fw-400 fs_20 align-items-center w-100"
                      >
                        <div className="col-8 p-0 text-left fw-400 fs_20">
                          {LABEL().RECEIPT_GIFT_CARD}{' '}
                          {
                            props.seat?.paymentCheck?.giftCard
                              ?.displayAccountNumber
                          }
                        </div>
                        <div className="col-4 p-0 text-right fw-400 fs_20">
                          {currenySymbol}
                          {props?.seat?.paymentCheck?.giftCard?.paymentAmount?.toFixed(
                            2
                          )}
                        </div>
                      </div>
                    )}
                    {/* Due */}
                    {countryCode !== '44' &&
                      ![20, 17, 18].includes(paymentType) &&
                      !props?.seat?.paidAmount == 0 && (
                        <div
                          id="innerDiv"
                          className="row mx-0 fw-600 fs_20 align-items-center w-100"
                        >
                          <div
                            className={cn(
                              'col-8 p-0 text-left fw-600 fs_20',
                              styles.paymentStyle
                            )}
                          >
                            Due
                          </div>
                          <div
                            className={cn(
                              'col-4 p-0 text-right fw-600 fs_20',
                              styles.paymentStyle
                            )}
                          >
                            {currenySymbol}
                            {props?.seat?.paymentCheck?.paymentAmount >= 0
                              ? Number(
                                  props?.seat?.paymentCheck?.paymentAmount
                                )?.toFixed(2)
                              : Number(tableData?.unpaidAmount)?.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {getObjectValue(() => paidTips > 0, false) &&
                      [1, 2, 10, 9].includes(paymentType) && (
                        <div
                          id="innerDiv"
                          className={cn(
                            'row m-0 fw-normal fs_20 h-auto pb-1 w-100',
                            [1].includes(paymentType) && 'fs_20 pb-2'
                          )}
                        >
                          <div className="col-8 p-0 text-left">
                            {LABEL().PAID_TIPS}{' '}
                          </div>
                          <div className={cn('col-4 p-0 text-right')}>
                            {currenySymbol}
                            {Number(paidTips)?.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {getObjectValue(() => unpaidTips > 0, false) &&
                      [1, 2, 10, 9].includes(paymentType) && (
                        <div
                          id="innerDiv"
                          className={cn(
                            'row m-0 fw-normal fs_20 h-auto pb-1 w-100',
                            [1].includes(paymentType) && 'fs_20 pb-2'
                          )}
                        >
                          <div className="col-8 p-0 text-left">
                            {LABEL().UNPAID_TIPS}{' '}
                          </div>
                          <div className={cn('col-4 p-0 text-right')}>
                            {currenySymbol}
                            {Number(unpaidTips)?.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {[2, 5, 6, 11, 12].includes(paymentType) &&
                      paymentFlowType === 4 &&
                      getObjectValue(() => tipAmount > 0, false) && (
                        <div
                          id="innerDiv"
                          className={cn(
                            'row m-0 fw-normal pb-1 w-100',
                            !isLandScape ? 'fs_20' : 'fs-14'
                          )}
                        >
                          <div className={cn('col-8 p-0 text-left')}>
                            {LABEL().TIP}
                          </div>
                          <div className={cn('col-4 p-0 text-right')}>
                            {currenySymbol}
                            {(tipAmount && Number(tipAmount)?.toFixed(2)) ||
                              tableData?.tipAmount?.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {[2, 3, 4, 5, 6, 11, 12].includes(paymentType) &&
                      paymentFlowType === 3 &&
                      getObjectValue(() => tipAmount > 0, false) && (
                        <div
                          id="innerDiv"
                          className="row m-0 fw-normal fs_20 pb-1 w-100"
                        >
                          <div className="col-8 p-0 text-left">
                            {LABEL().TIP}{' '}
                          </div>
                          <div className={cn('col-4 p-0 text-right')}>
                            {currenySymbol}
                            {(tipAmount && Number(tipAmount)?.toFixed(2)) ||
                              tableData?.tipAmount?.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {[23].includes(paymentType) ? (
                      <div
                        id="innerDiv"
                        className="row m-0 fw-normal fs_20 pb-2 w-100"
                      >
                        <div className={cn('col-8 p-0 text-left')}>
                          {LABEL().TIP}
                        </div>
                        <div className={cn('col-4 p-0 text-right')}>
                          {currenySymbol}
                          {(tipAmount && Number(tipAmount)?.toFixed(2)) ||
                            tableData?.tipAmount?.toFixed(2)}
                        </div>
                      </div>
                    ) : null}
                    {[5, 6, 11].includes(paymentType) && (
                      <div
                        id="innerDiv"
                        className="row m-0 fw-700 fs-18 pb-1 w-100"
                      >
                        <div className="col-6 p-0 text-left">
                          {LABEL().PAYMENT}{' '}
                        </div>
                        {countryCode === '44' &&
                        Number(urlSearchParams('screenType')) === 5 ? (
                          <div className="col-4 p-0 text-right">
                            {currenySymbol}
                            {tableData?.totalAmount?.toFixed(2)}
                          </div>
                        ) : (
                          <div className="col-4 p-0 text-right">
                            {currenySymbol}
                            {tableData &&
                              (
                                tableData?.totalAmount + Number(tipAmount)
                              )?.toFixed(2)}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          {isKiosk && (
            <div
              id="innerDiv"
              className={cn(
                'col-12 od-header background-primary w-100 row mx-0 justify-content-center align-items-center fw-600 od-color h-10',
                fontSize
              )}
              style={{
                borderBottomLeftRadius: '5px',
                borderBottomRightRadius: '5px',
              }}
            >
              {[5, 6, 11, 17, 18, 20].includes(paymentType) ? (
                <>
                  {countryCode === '44' &&
                  Number(urlSearchParams('screenType')) === 5 ? (
                    <>
                      {isKiosk
                        ? LABEL().PAYMENT_COMPLETED
                        : LABEL().TOTAL_PAYMENT_PAID}
                      : {currenySymbol}
                      {tableData?.totalAmount?.toFixed(2)}
                    </>
                  ) : (
                    <>
                      {isKiosk
                        ? LABEL().PAYMENT_COMPLETED
                        : LABEL().TOTAL_PAYMENT_PAID}
                      : {currenySymbol}
                      {tableData &&
                        (tableData.totalAmount + Number(tipAmount))?.toFixed(2)}
                    </>
                  )}
                </>
              ) : (
                <>
                  {isKiosk ? LABEL().PAYMENT_DUE : LABEL().TOTAL_DUE_PAYMENT}:{' '}
                  {currenySymbol}
                  {tableData && !isDefaultMode && countryCode === '44'
                    ? (
                        Number(tableData.totalAmount) +
                        Number(tableData.taxAmount) -
                        tableData.paidAmount +
                        Number(tipAmount) +
                        Number(unpaidTips)
                      ).toFixed(2)
                    : (
                        Number(tableData.totalAmount).toFixed(2) -
                        tableData.paidAmount +
                        Number(tipAmount) +
                        Number(unpaidTips)
                      ).toFixed(2)}
                </>
              )}
            </div>
          )}
        </>
      )}
      {[7, 8].includes(paymentType) && (
        <div
          id="innerDiv"
          className={cn(
            'col-12 row fs-12 m-0 d-flex align-items-start justify-content-center text-center',
            [8].includes(paymentType) ? 'h-100' : 'h-40'
          )}
        >
          <div
            className="col-12 h-100 d-flex align-items-start justify-content-center"
            style={{ width: '250px' }}
          >
            <img className="w-60" src={ERROR} alt="error" />
          </div>
        </div>
      )}
      {[13].includes(paymentType) && (
        <div className="w-100 h-100 position-relative">
          <div
            className={cn('col-12 text-center h-85 ', {
              'd-none': !supportsTips,
              'justify-content': 'space-between',
            })}
          >
            <NumberKeyboard
              name="tipsAmount"
              haveCurrency={
                active === `Other ${LABEL().CURRENCY_SYMBOL}`
                  ? `${LABEL().CURRENCY_SYMBOL}`
                  : '%'
              }
              type="number"
              isDotRequired
              value={active === `${LABEL().ROUND_UP}` ? '' : keyboardValue}
              onChange={e => {
                handleKeyboardValue(e);
                if (
                  [`Other ${LABEL().CURRENCY_SYMBOL}`, 'Other $'].includes(
                    active
                  )
                ) {
                  handleButtonClick(active, e);
                } else {
                  handleButtonClick('Other %', e);
                }
              }}
            />
          </div>
          <div
            className="col-12 p-0 position-absolute h-15 border od-text-primary od-container-card-background background-secondary
            border-color-secondary  fs-12"
            style={{
              bottom: '0px',
              left: '0px',
              borderBottomLeftRadius: '5px',
              borderBottomRightRadius: '5px',
            }}
          >
            <div className="row m-0 fw-600 fs-14">
              <div className="col-4 text-left">
                {LABEL().PAYEMENT_TOTAL_DUE}{' '}
              </div>
              <div className="col-8 text-right">
                {currenySymbol}
                {tableData &&
                  (tableData.totalAmount - tableData.paidAmount).toFixed(2)}
              </div>
            </div>
            <div className="row m-0 fw-normal fs-22">
              <div className="col-4 text-left">{LABEL().TIP}</div>
              <div
                className={cn(
                  isKiosk ||
                    isTableTop ||
                    deviceInfo?.deviceGroup?.startMode === 0
                    ? 'col-6 p-0 text-right'
                    : 'col-2 p-0'
                )}
              >
                {currenySymbol}
                {(tipAmount && Number(tipAmount)?.toFixed(2)) ||
                  tableData?.tipAmount?.toFixed(2)}
              </div>
            </div>
            <div className="row m-0 fw-700">
              <div className="col-4 text-left">{LABEL().RECEIPT_PAYMENT} </div>
              <div className="col-8 text-right">
                {currenySymbol}
                {tableData &&
                  (
                    tableData.totalAmount -
                    tableData.paidAmount +
                    Number(tipAmount)
                  ).toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      )}
      {![1].includes(paymentType) &&
        isLandScape &&
        !props.viewDetails &&
        isPaymentTerminal && (
          <div className="d-flex text-center justify-content-center align-content-center">
            <div
              className={styles.closeButton}
              tabIndex="0"
              role="button"
              onClick={props.viewDetailsOnClose}
              style={{ fontSize: '24px' }}
            >
              close
            </div>
          </div>
        )}
    </>
  );
};

const mapStateToProps = ({payment}) => ({
  paymentLandscapeOrientation: payment.paymentLandscapeOrientation
})

const MemoizedReceiptScreen = memo(ReceiptScreen);

export default connect(mapStateToProps)(MemoizedReceiptScreen);
